import { toast } from 'react-toastify';

const MyToast = (type, message, position = "top-right", time = 1000) => {
    toast.dismiss();

    const defaultOptions = {
        position: position,
        autoClose: time,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        // theme: "dark",
    };

    const options = {
        ...defaultOptions,
        ...(type === 'e' ? { autoClose: 4000, type: 'error' } : {}),
        ...(type === 's' ? { autoClose: time, type: 'success' } : {}),
        ...(type === 'w' ? { autoClose: 4000, type: 'warning' } : {}),
    };

    toast(message, options);
};

export default MyToast;